import { useState } from "react";
import { isMentionOperation } from "../ReactQuill";
const getStaticTextAtomContent = (op, isLast) => {
    let text = op.insert;
    if (isLast && text.endsWith("\n")) {
        text = text.slice(0, -1);
    }
    return text;
};
export const useAiTextEditing = ({ buildRichTextContentFromString, quillRef }) => {
    var _a;
    const [currentTextModification, setCurrentTextModification] = useState(null);
    const [aITextEditingMenuAnchor, setAITextEditingMenuAnchor] = useState(null);
    const [editingDialogAnchor, setEditingDialogAnchor] = useState(null);
    const [customPrompt, setCustomPrompt] = useState("");
    const richTextValue = (_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor().getContents();
    const extractStringFromDeltaStatic = (deltaStatic) => {
        return deltaStatic.ops.reduce((acc, op, index) => {
            if (isMentionOperation(op)) {
                acc += op.insert.mention.value;
            }
            else {
                acc += getStaticTextAtomContent(op, index === deltaStatic.ops.length - 1);
            }
            return acc;
        }, "");
    };
    const closeAiTextEditingPopover = () => {
        setCurrentTextModification(null);
        setCustomPrompt("");
    };
    const handleOnReplace = (value) => {
        var _a;
        closeAiTextEditingPopover();
        if (!richTextValue || !buildRichTextContentFromString) {
            return;
        }
        const richTextContent = buildRichTextContentFromString(value);
        (_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor().setContents(richTextContent, "user");
    };
    const contentToModify = richTextValue ? extractStringFromDeltaStatic(richTextValue) : "";
    return {
        aITextEditingMenuAnchor,
        setAITextEditingMenuAnchor,
        editingDialogAnchor,
        setEditingDialogAnchor,
        currentTextModification,
        setCurrentTextModification,
        handleOnReplace,
        contentToModify,
        closeAiTextEditingPopover,
        customPrompt,
        setCustomPrompt
    };
};
//# sourceMappingURL=useAiTextEditing.js.map